import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IPageWillMountDisposers } from './types'

export const PageWillMountDisposers = withDependencies([], (): IPageWillMountDisposers => {
	const disposers: Array<() => void> = []
	return {
		register: (dispose) => {
			disposers.push(dispose)
		},
		disposeAll: () => {
			disposers.forEach((dispose) => dispose())
		},
	}
})
